<template>
    <div class="contact">
        <br />
        <h4>Owner, Joseph Slomka, C of Q</h4>
        <h4>Cell: 905 577 1710</h4>
        <h4>Email: heartwoodcarpentry@outlook.com</h4>
        <h4>www.heartwoodcarpentry.org</h4>
        <br />
        <h4>Any questions, comments, criticisms or concerns are welcome.</h4>
        <br />
        <v-img class="contact_img" :src="'https://static.heartwoodcarpentry.org/contact.jpeg'" alt="contact-image" />
    </div>
</template>

<script>
export default {
    name: 'Contact',
};
</script>

<style scoped>
h4 {
    text-align: center;
    color: white;
    font-weight: bolder;
}
.contact_img {
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
}
</style>
